import PropTypes from "prop-types";
import React from "react";
import Alert from "react-bootstrap/Alert";
import { Redirect } from "react-router-dom";
import { SimpleFetch } from "ui/fetch/simple-fetch";
import { NavLoader } from "ui/loader";
import { Page } from "view/layout/page";

import { ConfigureNetworkParams } from "./configure-v2";

class ConfigureNetworkPageV2 extends React.PureComponent {
  static get propTypes() {
    return {
      addErrorMessage: PropTypes.func.isRequired,
      apps: ConfigureNetworkParams.propTypes.apps,
      network: PropTypes.object,
      readonly: ConfigureNetworkParams.propTypes.readonly,
      storesLoaded: PropTypes.bool.isRequired,
      updateParams: ConfigureNetworkParams.propTypes.updateParams,
    };
  }

  render() {
    const { network, storesLoaded } = this.props;
    const networkName = network ? network.name : "network";

    if (!storesLoaded) {
      return <NavLoader.Proxy />;
    }

    if (!network) {
      return <Redirect to="/404" />;
    }

    return (
      <Page title={`Configure ${networkName}`}>
        <SimpleFetch.Network
          injectAs="network"
          networkId={network.id}
          errorChild={
            <Alert variant="danger">Could not fetch network for device.</Alert>
          }
        >
          <ConfigureNetworkParams {...this.props} />
        </SimpleFetch.Network>
      </Page>
    );
  }
}

export { ConfigureNetworkPageV2 };
